import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <section className="py-20">
        <div className="max-w-lg mx-auto px-6">
          <div className="bg-white rounded-lg shadow-lg p-8 text-center">
            <div className="w-20 h-20 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center">
              <XCircle className="w-12 h-12 text-gray-400" />
            </div>
            <h1 className="text-2xl font-bold text-gray-800 mb-4">
              Payment Cancelled
            </h1>
            <p className="text-gray-600 mb-6">
              Your payment was cancelled. No charges were made to your account.
            </p>
            <p className="text-gray-500 text-sm mb-8">
              If you have any questions about our plans, please contact support.
            </p>
            
            <div className="space-y-3">
              <button
                onClick={() => navigate('/pricing')}
                className="w-full px-6 py-3 bg-yellow-500 hover:bg-yellow-600 text-white rounded-md font-semibold transition-colors"
              >
                View Plans Again
              </button>
              <button
                onClick={() => navigate('/dashboard')}
                className="w-full px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md font-semibold transition-colors"
              >
                Go to Dashboard
              </button>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default PaymentCancel;
